"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//import uuidv1 = require('uuid/v1');
const uuidv1 = require("uuid/v1");
const TypeScriptUtils_1 = require("../../Common/TypeScriptUtils");
class DomainEvent {
    //public constructor(version: number, category: string, name: string, entityId: string, body: object = null)
    //public constructor(id: string, version: number, category: string, name: string, body: object = null, entityId: string = "", occurredOnUtc: number = 0, isLocal: boolean = false)
    constructor(para) {
        this.id = "";
        this.version = 0;
        this.category = "";
        this.name = "";
        this.body = {};
        this.entityId = "";
        this.occurredOnUtc = 0;
        this._isLocal = false;
        if (para) {
            this.id = (para.id) ? para.id : DomainEvent.generateId();
            this.version = para.version;
            this.category = para.category;
            this.name = para.name;
            this.body = (para.body) ? para.body : {};
            this.entityId = (para.entityId) ? para.entityId : "";
            this.occurredOnUtc = (para.occurredOnUtc) && (para.occurredOnUtc > 0) ? para.occurredOnUtc : Date.now();
            this._isLocal = (para.isLocal) ? para.isLocal : false;
        }
    }
    get isLocal() { return this._isLocal; }
    toString() { return JSON.stringify(this, null, 4); }
    bodyTo() {
        if (typeof this.body === "string") {
            return TypeScriptUtils_1.parseJsonString(this.body);
        }
        else {
            return this.body;
        }
    }
    isValid() {
        return !TypeScriptUtils_1.isNullOrEmpty(this.id)
            && !TypeScriptUtils_1.isNullOrEmpty(this.category)
            && !TypeScriptUtils_1.isNullOrEmpty(this.name);
    }
    toLocalEvent() {
        //return new DomainEvent(this.id, this.version, this.category, this.name, this.body, this.entityId, this.occurredOnUtc, true);
        return new DomainEvent({
            id: this.id,
            version: this.version,
            category: this.category,
            name: this.name,
            body: this.body,
            entityId: this.entityId,
            occurredOnUtc: this.occurredOnUtc,
            isLocal: true,
        });
    }
    static generateId() {
        return uuidv1();
    }
    static deserializeFromJsonString(jsonString) {
        const parsed = JSON.parse(jsonString);
        //const deSerialized = new RtcCommand(<RtcComamndConstructorParameter>parsed);
        const deSerialized = new DomainEvent();
        Object.assign(deSerialized, parsed);
        return deSerialized;
    }
}
exports.DomainEvent = DomainEvent;
//# sourceMappingURL=DomainEvent.js.map